import { apiInstance } from "./api"

const endpoint = "/snapbox"

export const getSnapboxDeliveryCategory = async (branchId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/delivery-category/${branchId}`)

  return response.data
}